import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "member-modal"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "toolbox"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "仅支持选择团队当前待开始/进行中的学术会议")], -1);

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" ~ ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" ~ ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定");

import { ref, computed, watch, nextTick } from 'vue';
import { myProgresstList } from '@/request';
import Tool from '@/utils/tool';
export default {
  name: 'meeting-modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    params: Object,
    selectedIds: Array
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    watch(() => props.modelValue, v => {
      if (v) {
        keyword.value = '';
        getList();
      }
    });
    const keyword = ref('');
    const table = ref();
    const tableData = ref([]);

    function getList() {
      myProgresstList().then(res => {
        // let list = [...res.data, ...res.data]
        tableData.value = res.data;
      });
    }

    const selectedMeetingId = ref('');

    function submit() {
      let selectedMeetingInfo = tableData.value.find(v => v.scienceId == selectedMeetingId.value);
      emit('success', selectedMeetingInfo);
      visible.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "请选择会议",
        width: "900px",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_table, {
          data: tableData.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "选择",
            width: "55"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_radio, {
              name: "select",
              modelValue: selectedMeetingId.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedMeetingId.value = $event),
              label: scope.row.scienceId
            }, null, 8, ["modelValue", "label"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "会议名称",
            prop: "scienceName"
          }), _createVNode(_component_el_table_column, {
            label: "会议时间",
            width: "170"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.startTime), 1), _hoisted_3, _createElementVNode("span", null, _toDisplayString(scope.row.endTime), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "推广时间",
            width: "170"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.proStartTime), 1), _hoisted_4, _createElementVNode("span", null, _toDisplayString(scope.row.proEndTime), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "参与团队",
            prop: "teamNames"
          }), _createVNode(_component_el_table_column, {
            label: "状态",
            prop: "status",
            width: "80"
          })]),
          _: 1
        }, 8, ["data"])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};